import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';

@Component({
  selector: 'app-csr-campaign-details',
  templateUrl: './csr-campaign-details.component.html',
  styleUrl: './csr-campaign-details.component.scss',
})
export class CsrCampaignDetailsComponent implements OnInit {
  ngoId: string = null;
  projectId: string = null;
  campaignId: string = null;

  constructor(
    private readonly route: ActivatedRoute,
    public readonly localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const encryptedString = params['data'];
      const decryptedParams =
        this.localStorageService.decryptObjectUrl(encryptedString);
      if (decryptedParams) {
        this.campaignId = decryptedParams.id;
        this.ngoId = decryptedParams.ngo_id;
        this.projectId = decryptedParams.project_id;
      }
    });
  }
}
